/*
 * RESADE rs-popup.js (Runde Popup, 24.10.2026, Akte docs/resade/popup-2026-10-24/)
 * Steuert das Newsletter-Fenster aus sections/rs-popup.liquid. Kein Framework, mehrfach ladbar (Theme-Editor).
 *
 * 1. Rückkehr nach dem Absenden geht allem vor. Shopify lädt nach dem Kundenformular neu (fetch lehnt Shopify mit 403
 *    ab, hCaptcha braucht den echten Versand, ein Iframe scheitert an x-frame-options, technik.md 4). Erfolg nur, wenn
 *    customer_posted=true UND das Fenster gesendet hat (Sprungziel #rs-popup-form oder frischer Merker aus dem
 *    Absenden): form.posted_successfully? gilt für jedes Kundenformular der Seite, auch für das Band rs-newsletter.
 *    Fehler (Shopify rendert unter /contact#rs-popup-form) öffnet das Fenster mit der Meldung am Feld. Hat das Band
 *    gesendet, merkt sich das Fenster „angemeldet“ und bleibt zu. Danach Adresse aufräumen und Scrollposition zurück.
 * 2. Sperren beim Laden: Merker im Browser (angemeldet, kam aus einer Mail, geschlossen), Besuch aus einer Mail
 *    (utm_medium=email, utm_source=shopify_email, Loox-Links), Rabatt-Cookie discount_code. Ohne sessionStorage nie
 *    (lieber gar nicht als auf jeder Seite).
 * 3. Fällig nach den Sekunden aus data-sekunden, gezählt nur bei sichtbarer Seite und je Seite neu; nichts davon wird
 *    gespeichert (recht.md 6). Dazu einmal bedient (Scrollen, Tippen, Taste), damit das Fenster nie das LCP-Element
 *    einer unberührten Seite wird.
 * 4. Gezeigt erst im ruhigen Moment: 1 s ohne Bewegung, Seite sichtbar, Fenster mindestens 500 px hoch, kein Fokus in
 *    einem Feld, nichts anderes offen (Dialoge, Schublade, Galerie, Blatt, Shrine-Menü, Loox-Hinweis, Cookie-Banner
 *    und seine Einstellungen), auf Kaufseiten die Kaufbühne nicht im Bild, auf der Listicle erst nach dem
 *    Angebotsblock. Geprüft wird nur bei Anlässen (Bewegung, Schließen, Einwilligung, Größe), nie im Takt.
 * 5. Schließen (X, „Nein danke“, Esc, Tipp auf den Schleier): Pause aus data-pause. Merker nur im sessionStorage; mit
 *    Einwilligung in Präferenzen zusätzlich im localStorage (geschlossen data-pause Tage, Mail 180, angemeldet 365).
 *    Keine Adresse, keine Kennung, nichts davon an dataLayer, GTM oder Stape. Fokus zurück auf das vorherige Element.
 * 6. Absenden: nur den Merker „gesendet“ schreiben („angemeldet“ erst, wenn Shopify die Anmeldung angenommen hat),
 *    Knopf mit Ladekreis, nie preventDefault und nie form.submit() (beides umginge Shopifys hCaptcha). Das Fenster
 *    verlässt dabei den Top Layer (close, dann show), damit eine sichtbare hCaptcha-Aufgabe am Ende von body nicht
 *    verdeckt und inert unter dem modalen Fenster liegt. Die Aufgabe selbst hat keinen Ausgang: ohne Seitenwechsel
 *    gibt der Knopf nach 6 s wieder frei (ebenso nach der Zurück-Taste aus dem Cache), und wer das Fenster schließt
 *    (X, „Nein danke“, Esc), schließt die Aufgabe mit.
 * 7. Erfolg: Kopieren (Zwischenablage, sonst Markieren), Einlösen auf der Kaufseite im Hintergrund über den Rabattlink
 *    mit redirect=/cart.js (der Code steht danach im Warenkorb, die Schublade frischt auf), sonst folgt der Link.
 * 8. Messung im vorhandenen dataLayer: event rs_popup, rs_popup_aktion gezeigt, zu (rs_popup_art x, nein, esc,
 *    schleier, weiter), absenden, angemeldet, fehler, kopiert, eingeloest.
 * Vorschau (nur unveröffentlichtes Theme, data-vorschau): ?rs_popup=1 sofort, ?rs_popup=erfolg im Erfolg. Im
 * Theme-Editor öffnet das Fenster nur, wenn die Section ausgewählt ist, und merkt sich nichts.
 */
(function () {
  'use strict';

  var SCHLUESSEL = 'rs-popup';
  var GESENDET = 'rs-popup-gesendet';
  var RANG = { zu: 1, mail: 2, an: 3 };
  var TAGE = { mail: 180, an: 365 };
  var FRISCH_MS = 15 * 60 * 1000;

  function senden(aktion, art) {
    try {
      window.dataLayer = window.dataLayer || [];
      var daten = { event: 'rs_popup', rs_popup_aktion: aktion };
      if (art) daten.rs_popup_art = art;
      window.dataLayer.push(daten);
    } catch (fehler) { /* Messung darf nie stören */ }
  }

  function ruhigeBewegung() {
    if (document.documentElement.classList.contains('ohne-bewegung')) return true;
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function sichtbar(el) {
    if (!el || !el.getClientRects().length) return false;
    var stil = window.getComputedStyle(el);
    return stil.visibility !== 'hidden' && stil.display !== 'none';
  }

  function einrichten() {
    var dlg = document.querySelector('[data-rs-popup]');
    if (!dlg || dlg.rsPopup || typeof dlg.showModal !== 'function') return;
    dlg.rsPopup = true;

    var html = document.documentElement;
    var form = dlg.querySelector('form');
    var feld = dlg.querySelector('input[type="email"]');
    var knopf = form ? form.querySelector('button[type="submit"]') : null;
    var seite = dlg.getAttribute('data-seite') || '';
    var schwelleMs = (parseInt(dlg.getAttribute('data-sekunden'), 10) || 30) * 1000;
    var pauseTage = parseInt(dlg.getAttribute('data-pause'), 10) || 14;
    var vorschau = dlg.hasAttribute('data-vorschau');
    var editor = !!(window.Shopify && window.Shopify.designMode);

    var offen = false;
    var erledigt = false;
    var gesendet = false;
    var imEditor = false;
    var ansicht = 'angebot';
    var vorherFokus = null;
    var ohneMessung = false;

    // Vorschau und Editor zählen nicht mit
    function messen(aktion, art) {
      if (!imEditor && !ohneMessung) senden(aktion, art);
    }

    /* ---------- Merker (recht.md 6) ---------- */

    function speicherGeht() {
      try {
        sessionStorage.setItem(SCHLUESSEL + '-probe', '1');
        sessionStorage.removeItem(SCHLUESSEL + '-probe');
        return true;
      } catch (fehler) {
        return false;
      }
    }

    function praeferenzen() {
      try {
        return !!(window.rsEinwilligung && window.rsEinwilligung.stand().praeferenzen);
      } catch (fehler) {
        return false;
      }
    }

    function merkerLesen() {
      var wert = '';
      try { wert = sessionStorage.getItem(SCHLUESSEL) || ''; } catch (fehler) { /* gesperrt */ }
      if (!RANG[wert]) wert = '';
      try {
        var roh = localStorage.getItem(SCHLUESSEL);
        if (roh) {
          var lokal = JSON.parse(roh);
          if (lokal && RANG[lokal.wert] && lokal.bis > Date.now()) {
            if (RANG[lokal.wert] > (RANG[wert] || 0)) wert = lokal.wert;
          } else {
            localStorage.removeItem(SCHLUESSEL);
          }
        }
      } catch (fehler) { /* gesperrt oder kaputt: zählt als nicht gemerkt */ }
      return wert;
    }

    function merken(wert) {
      if (imEditor) return;
      var alt = merkerLesen();
      if ((RANG[alt] || 0) > RANG[wert]) return;
      try { sessionStorage.setItem(SCHLUESSEL, wert); } catch (fehler) { /* gesperrt */ }
      if (!praeferenzen()) return;
      var tage = TAGE[wert] || pauseTage;
      try {
        localStorage.setItem(SCHLUESSEL, JSON.stringify({ wert: wert, bis: Date.now() + tage * 864e5 }));
      } catch (fehler) { /* voll oder gesperrt */ }
    }

    function ausMail() {
      var s = location.search.toLowerCase();
      if (/[?&]utm_medium=email(&|$)/.test(s) || /[?&]utm_source=shopify_email(&|$)/.test(s)) return true;
      // Links aus Loox-Mails, Muster wie snippets/rs-loox-link.liquid
      if (/^\?(lx|lx_ep)=/.test(s) || /[?&]qv=/.test(s)) return true;
      return seite === 'produkt' && /[?&]ref=review(&|$)/.test(s);
    }

    function hatCodeCookie() {
      return /(^|;\s*)discount_code=/.test(document.cookie);
    }

    /* ---------- Ansichten, Öffnen, Schließen ---------- */

    function zeige(name) {
      var erfolg = dlg.querySelector('[data-rs-popup-ansicht="erfolg"]');
      if (name === 'erfolg' && !erfolg) name = 'angebot';
      ansicht = name;
      var alle = dlg.querySelectorAll('[data-rs-popup-ansicht]');
      for (var i = 0; i < alle.length; i++) alle[i].hidden = alle[i].getAttribute('data-rs-popup-ansicht') !== name;
      dlg.setAttribute('aria-labelledby', name === 'erfolg' ? 'rs-popup-erfolg-titel' : 'rs-popup-titel');
      dlg.classList.toggle('rs-popup--erfolg', name === 'erfolg');
    }

    // Das Foto (nur ab 990 px sichtbar) mit dem Blatt holen, sonst erscheint es erst nach dem Öffnen
    function bildVorladen() {
      var bild = dlg.querySelector('.rs-popup__bild img');
      if (bild && window.innerWidth >= 990 && bild.loading === 'lazy') bild.loading = 'eager';
    }

    var cssVersprechen = null;
    var cssDa = false;
    function cssLaden() {
      if (cssVersprechen) return cssVersprechen;
      bildVorladen();
      var href = dlg.getAttribute('data-css');
      cssVersprechen = new Promise(function (fertig) {
        if (!href || document.querySelector('link[data-rs-popup-css]')) {
          cssDa = true;
          fertig();
          return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.setAttribute('data-rs-popup-css', '');
        // Ein Versprechen, fertig bei load, error oder nach 3 s (ladezeit.md Regel 4)
        var uhr = setTimeout(fertig, 3000);
        link.onload = function () { cssDa = true; clearTimeout(uhr); fertig(); };
        link.onerror = function () { clearTimeout(uhr); fertig(); };
        document.head.appendChild(link);
      });
      return cssVersprechen;
    }

    // art: angebot (von selbst, mit allen Prüfungen), erfolg und fehler (Rückkehr nach dem Absenden, immer),
    // vorschau und editor (ohne Prüfungen, ohne Messung)
    function oeffnen(art) {
      if (offen) return Promise.resolve();
      return cssLaden().then(function () {
        if (offen || !document.contains(dlg)) return;
        // Das Angebot nur mit eigenem Blatt und nur, wenn die Lage noch stimmt
        if (art === 'angebot' && (!cssDa || erledigt || gesendet || belegt())) return;
        zeige(art === 'erfolg' ? 'erfolg' : 'angebot');
        vorherFokus = document.activeElement;
        try {
          dlg.showModal();
        } catch (fehler) {
          return;
        }
        offen = true;
        html.classList.add('rs-popup-offen');
        tastaturAnpassen();
        engPruefen();
        var ziel = dlg.querySelector('[data-rs-popup-ansicht]:not([hidden]) .rs-popup__titel');
        if (art === 'fehler' && feld) ziel = feld;
        if (ziel) {
          try { ziel.focus({ preventScroll: true }); } catch (fehler) { /* alte Browser */ }
        }
        if (art === 'angebot') messen('gezeigt');
        else if (art === 'erfolg' || art === 'fehler') messen(art === 'erfolg' ? 'angemeldet' : 'fehler');
      });
    }

    // Passt die Einwilligung beim Öffnen nicht ganz in den sichtbaren Teil des Blatts, rückt sie vor den Knopf
    // (rs-popup.css, recht.md 1); gemessen relativ zum rollenden Teil, die Einfahrt verschiebt beide gleich
    function engPruefen() {
      dlg.classList.remove('rs-popup--eng');
      var hinweis = dlg.querySelector('.rs-popup__hinweis');
      if (ansicht !== 'angebot' || !hinweis) return;
      var innen = dlg.querySelector('.rs-popup__innen');
      var roller = window.getComputedStyle(dlg).overflowY === 'auto' || !innen ? dlg : innen;
      var oben = roller.getBoundingClientRect().top;
      if (hinweis.getBoundingClientRect().bottom - oben > roller.clientHeight + 1) dlg.classList.add('rs-popup--eng');
    }

    function fokusZurueck() {
      var z = vorherFokus;
      vorherFokus = null;
      if (z && z !== document.body && document.contains(z) && typeof z.focus === 'function') {
        try { z.focus({ preventScroll: true }); return; } catch (fehler) { /* weiter unten */ }
      }
      var main = document.getElementById('MainContent');
      if (main) {
        try { main.focus({ preventScroll: true }); } catch (fehler) { /* nichts */ }
      }
    }

    // Shopify setzt das unsichtbare hCaptcha ins Formular; seine Aufgabe hat keinen eigenen Ausgang. Schließt das
    // Fenster vor dem Seitenwechsel, schließt sie mit, sonst bliebe sie allein auf der Seite stehen.
    function aufgabeSchliessen() {
      var hc = window.hcaptcha;
      var rahmen = form ? form.querySelector('iframe[data-hcaptcha-widget-id]') : null;
      if (!gesendet || unterwegs || !rahmen || !hc || typeof hc.close !== 'function') return;
      try { hc.close(rahmen.getAttribute('data-hcaptcha-widget-id')); } catch (fehler) { /* bleibt Shopifys Sache */ }
    }

    function schliessen(art) {
      if (!offen) return;
      // Auch nach dem Absenden: „angemeldet“ setzt erst die Rückkehr und steht im Rang darüber
      if (ansicht === 'angebot') merken('zu');
      aufgabeSchliessen();
      erledigt = true;
      messen('zu', art);
      var fertig = function () {
        if (!offen) return;
        offen = false;
        dlg.classList.remove('ist-zu', 'rs-popup--gesendet');
        try { dlg.close(); } catch (fehler) { /* schon zu */ }
        html.classList.remove('rs-popup-offen');
        fokusZurueck();
      };
      if (ruhigeBewegung() || !dlg.matches(':modal')) {
        fertig();
        return;
      }
      dlg.classList.add('ist-zu');
      var uhr = setTimeout(fertig, 300);
      dlg.addEventListener('animationend', function ende(e) {
        if (e.target !== dlg) return;
        dlg.removeEventListener('animationend', ende);
        clearTimeout(uhr);
        fertig();
      });
    }

    dlg.addEventListener('cancel', function (e) {
      e.preventDefault();
      schliessen('esc');
    });

    // Tipp auf den Schleier: Druck und Klick müssen beide auf dem Fenster selbst liegen (Markieren im Text und
    // Loslassen daneben schließt nicht)
    var druckAufSchleier = false;
    dlg.addEventListener('pointerdown', function (e) { druckAufSchleier = e.target === dlg; });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg && druckAufSchleier) schliessen('schleier');
      druckAufSchleier = false;
    });

    var zuKnoepfe = dlg.querySelectorAll('[data-rs-popup-zu]');
    for (var z = 0; z < zuKnoepfe.length; z++) {
      zuKnoepfe[z].addEventListener('click', function () {
        schliessen(this.getAttribute('data-rs-popup-zu') || 'x');
      });
    }

    // Fokusring nur nach Tastaturbedienung (Muster data-rs-tastatur wie die Schublade); Esc schließt auch nach dem
    // Absenden, wenn das Fenster nicht mehr modal ist und der Browser kein cancel mehr schickt
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ') dlg.setAttribute('data-rs-tastatur', '');
      if (e.key === 'Escape' && offen && !dlg.matches(':modal')) schliessen('esc');
    });
    dlg.addEventListener('pointerdown', function () { dlg.removeAttribute('data-rs-tastatur'); });

    /* ---------- Tastatur am Handy (gestaltung.md 4.2) ---------- */

    function tastaturAnpassen() {
      var vv = window.visualViewport;
      if (!offen || !vv) return;
      var unten = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
      dlg.style.setProperty('--rs-popup-unten', unten + 'px');
      dlg.style.setProperty('--rs-popup-hoehe', Math.round(vv.height) + 'px');
    }
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', tastaturAnpassen);
      window.visualViewport.addEventListener('scroll', tastaturAnpassen);
    }
    if (feld) {
      feld.addEventListener('focus', function () {
        setTimeout(function () {
          if (offen && document.activeElement === feld) {
            try { feld.scrollIntoView({ block: 'nearest' }); } catch (fehler) { /* alte Browser */ }
          }
        }, 350);
      });
      // Eigene Meldungen in der Browserblase statt Englisch oder Systemsprache; geprüft wird nativ (required,
      // type email, pattern mit Punkt hinter dem @: name@anbieter ohne Endung lehnt sonst erst Shopify nach dem
      // Neuladen ab), so feuert bei falscher Eingabe gar kein submit und hCaptcha bleibt unberührt
      feld.addEventListener('invalid', function () {
        var leer = !feld.value.trim();
        feld.setCustomValidity(feld.getAttribute(leer ? 'data-rs-popup-leer' : 'data-rs-popup-ungueltig') || '');
      });
      feld.addEventListener('input', function () { feld.setCustomValidity(''); });
    }

    /* ---------- Absenden (technik.md 4) ---------- */

    var ladeUhr = 0;
    var unterwegs = false;
    function knopfFrei() {
      clearTimeout(ladeUhr);
      if (knopf) knopf.removeAttribute('aria-busy');
    }
    // Erst beim echten Seitenwechsel (nach bestandener Prüfung) feuert beforeunload
    window.addEventListener('beforeunload', function () { if (gesendet) unterwegs = true; });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !gesendet) return;
      unterwegs = false;
      knopfFrei();
      if (offen && merkerLesen() === 'an') {
        ohneMessung = true;
        schliessen('zurueck');
        ohneMessung = false;
      }
    });

    if (form) {
      form.addEventListener('submit', function () {
        if (imEditor) return;
        gesendet = true;
        unterwegs = false;
        try {
          sessionStorage.setItem(GESENDET, JSON.stringify({
            t: Date.now(),
            pfad: location.pathname + location.search,
            y: Math.round(window.scrollY || 0)
          }));
        } catch (fehler) { /* gesperrt: dann erkennt die Rückkehr das Sprungziel */ }
        if (knopf) knopf.setAttribute('aria-busy', 'true');
        messen('absenden');
        clearTimeout(ladeUhr);
        ladeUhr = setTimeout(function () { if (!unterwegs) knopfFrei(); }, 6000);
        if (dlg.matches(':modal')) {
          try {
            dlg.close();
            dlg.show();
            dlg.classList.add('rs-popup--gesendet');
          } catch (fehler) { /* bleibt modal */ }
        }
      });
    }

    /* ---------- Erfolg: Kopieren und Einlösen ---------- */

    var codeEl = dlg.querySelector('[data-rs-popup-code]');
    var status = dlg.querySelector('[data-rs-popup-status]');

    function melden(text) {
      if (!status) return;
      status.textContent = '';
      // kurz leeren, damit Vorleseprogramme dieselbe Meldung erneut ansagen
      setTimeout(function () { status.textContent = text; }, 40);
    }

    var kopierKnopf = dlg.querySelector('[data-rs-popup-kopieren]');
    if (kopierKnopf && codeEl) {
      var kopierText = kopierKnopf.textContent;
      kopierKnopf.addEventListener('click', function () {
        var code = codeEl.textContent.trim();
        var gut = function () {
          kopierKnopf.textContent = kopierKnopf.getAttribute('data-kopiert') || kopierText;
          melden('Code ' + code.split('').join(' ') + ' kopiert.');
          setTimeout(function () { kopierKnopf.textContent = kopierText; }, 2000);
          messen('kopiert');
        };
        var markieren = function () {
          try {
            var bereich = document.createRange();
            bereich.selectNodeContents(codeEl);
            var auswahl = window.getSelection();
            auswahl.removeAllRanges();
            auswahl.addRange(bereich);
          } catch (fehler) { /* nichts */ }
          melden('Code markiert. Jetzt kopieren.');
        };
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(gut, markieren);
        } else {
          markieren();
        }
      });
    }

    var einloesen = dlg.querySelector('[data-rs-popup-einloesen]');
    var weiter = dlg.querySelector('.rs-popup__weiter');
    if (einloesen && window.fetch) {
      einloesen.addEventListener('click', function (e) {
        e.preventDefault();
        if (einloesen.getAttribute('aria-busy') === 'true') return;
        einloesen.setAttribute('aria-busy', 'true');
        var code = codeEl ? codeEl.textContent.trim().toUpperCase() : '';
        fetch(einloesen.getAttribute('data-rs-popup-einloesen'), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then(function (antwort) {
            if (!antwort.ok) throw new Error(String(antwort.status));
            return antwort.json();
          })
          .then(function (korb) {
            var codes = (korb && korb.discount_codes) || [];
            var drin = codes.some(function (c) { return c && String(c.code).toUpperCase() === code; });
            if (!drin) throw new Error('Code fehlt im Warenkorb');
            einloesen.removeAttribute('aria-busy');
            einloesen.hidden = true;
            if (weiter) {
              weiter.hidden = false;
              try { weiter.focus({ preventScroll: true }); } catch (fehler) { /* nichts */ }
            }
            melden(einloesen.getAttribute('data-eingeloest') || '');
            messen('eingeloest');
            if (window.RSWarenkorb && typeof window.RSWarenkorb.aktualisieren === 'function') {
              try { window.RSWarenkorb.aktualisieren(); } catch (fehler) { /* Schublade frischt beim Öffnen auf */ }
            }
          })
          .catch(function () {
            // Rückfall: der normale Rabattlink, Shopify trägt den Code ein und kommt auf diese Seite zurück
            window.location.href = einloesen.href;
          });
      });
    }
    var weg = dlg.querySelector('[data-rs-popup-weg]');
    if (weg) weg.addEventListener('click', function () { messen('eingeloest'); });

    /* ---------- 1. Rückkehr nach dem Absenden ---------- */

    function rueckkehr() {
      var suche = location.search;
      var gepostet = /[?&]customer_posted=true(&|$)/.test(suche);
      var sprung = location.hash === '#rs-popup-form';
      var merker = null;
      try { merker = JSON.parse(sessionStorage.getItem(GESENDET) || 'null'); } catch (fehler) { merker = null; }
      var frisch = !!(merker && typeof merker.t === 'number' && Date.now() - merker.t < FRISCH_MS);
      var vomBand = /^#rs-newsletter-/.test(location.hash);
      if (frisch || sprung) {
        try { sessionStorage.removeItem(GESENDET); } catch (fehler) { /* nichts */ }
      }
      var unserer = sprung || (frisch && !vomBand);
      if (unserer && gepostet && dlg.querySelector('[data-rs-popup-erfolg]')) return { art: 'erfolg', merker: merker };
      if (unserer && dlg.querySelector('[data-rs-popup-fehler]')) return { art: 'fehler', merker: merker };
      if (frisch && /[?&]form_key=/.test(suche)) return { art: 'nochmal', merker: merker };
      if (gepostet) return { art: 'band', merker: null };
      return null;
    }

    function adresseAufraeumen(merker) {
      try {
        var url = new URL(location.href);
        url.searchParams.delete('customer_posted');
        url.hash = '';
        var ziel = url.pathname + url.search;
        if (url.pathname.replace(/\/+$/, '') === '/contact' && merker && merker.pfad) ziel = merker.pfad;
        history.replaceState(history.state, '', ziel);
      } catch (fehler) { /* alte Browser: Adresse bleibt */ }
    }

    function scrollZurueck(merker) {
      if (!merker || !merker.y) return;
      var pfad = String(merker.pfad || '').split('?')[0];
      if (pfad && pfad !== location.pathname) return;
      var gerollt = false;
      var merkeRollen = function () { gerollt = true; };
      window.addEventListener('wheel', merkeRollen, { passive: true, once: true });
      window.addEventListener('touchstart', merkeRollen, { passive: true, once: true });
      var setzen = function () {
        if (!gerollt) window.scrollTo({ top: merker.y, behavior: 'instant' });
      };
      requestAnimationFrame(setzen);
      if (document.readyState !== 'complete') window.addEventListener('load', setzen, { once: true });
    }

    /* ---------- Theme-Editor ---------- */

    if (editor) {
      document.addEventListener('shopify:section:select', function (e) {
        if (!document.contains(dlg) || !e.detail || e.detail.sectionId !== 'rs-popup') return;
        imEditor = true;
        erledigt = false;
        oeffnen('editor');
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (!document.contains(dlg) || !e.detail || e.detail.sectionId !== 'rs-popup') return;
        schliessen('editor');
      });
      return;
    }

    var zurueck = rueckkehr();
    if (zurueck && zurueck.art === 'erfolg') {
      erledigt = true;
      merken('an');
      adresseAufraeumen(zurueck.merker);
      oeffnen('erfolg').then(function () { scrollZurueck(zurueck.merker); });
      return;
    }
    if (zurueck && (zurueck.art === 'fehler' || zurueck.art === 'nochmal')) {
      erledigt = true;
      // form_key braucht Shopifys Prüfskript nach DOMContentLoaded zum Auffüllen, dann die Adresse lassen
      if (zurueck.art === 'fehler') adresseAufraeumen(zurueck.merker);
      oeffnen('fehler').then(function () { scrollZurueck(zurueck.merker); });
      return;
    }
    if (zurueck && zurueck.art === 'band') {
      merken('an');
      return;
    }

    /* ---------- Vorschau ---------- */

    if (vorschau) {
      var wunsch = (location.search.match(/[?&]rs_popup=([a-z0-9]+)/i) || [])[1];
      if (wunsch) {
        ohneMessung = true;
        oeffnen(wunsch.toLowerCase() === 'erfolg' ? 'erfolg' : 'vorschau');
        return;
      }
    }

    /* ---------- 2. Sperren ---------- */

    if (!speicherGeht() || merkerLesen() || hatCodeCookie()) return;
    if (ausMail()) {
      merken('mail');
      return;
    }

    /* ---------- 3. und 4. Zeit, Bedienung, ruhiger Moment ---------- */

    var sichtbarMs = 0;
    var sichtbarSeit = document.visibilityState === 'visible' ? Date.now() : 0;
    var zeitUm = false;
    var bedient = false;
    var letzteBewegung = 0;
    var uhr = 0;
    var ruheUhr = 0;
    var cssUhr = 0;
    var kaufbuehneImBild = false;
    var angebotGesehen = seite !== 'listicle';

    function verbleibend() {
      return schwelleMs - sichtbarMs - (sichtbarSeit ? Date.now() - sichtbarSeit : 0);
    }

    function uhrStellen() {
      clearTimeout(uhr);
      clearTimeout(cssUhr);
      if (!sichtbarSeit || zeitUm || erledigt) return;
      var rest = verbleibend();
      if (rest <= 0) {
        zeitUm = true;
        bald();
        return;
      }
      // Das Blatt 5 s vorher holen, dann steht es beim Öffnen schon da
      cssUhr = setTimeout(cssLaden, Math.max(0, rest - 5000));
      uhr = setTimeout(uhrStellen, rest + 50);
    }

    function bald(ms) {
      if (erledigt || offen) return;
      clearTimeout(ruheUhr);
      ruheUhr = setTimeout(versuchen, ms == null ? 1000 : ms);
    }

    function belegt() {
      if (document.querySelector('dialog[open]:not([data-rs-popup])')) return true;
      if (/(^|\s)(rs-warenkorb-offen|rs-ohne-scroll|rs-galerie-offen|rs-blatt-offen)(\s|$)/.test(html.className)) return true;
      if (document.body && /(^|\s)overflow-hidden/.test(document.body.className)) return true;
      if (document.querySelector('.rs-lx-link__karte')) return true;
      if (sichtbar(document.getElementById('shopify-pc__banner'))) return true;
      if (sichtbar(document.getElementById('shopify-pc__prefs'))) return true;
      var modale = document.querySelectorAll('[aria-modal="true"]');
      for (var i = 0; i < modale.length; i++) {
        if (!dlg.contains(modale[i]) && sichtbar(modale[i])) return true;
      }
      var aktiv = document.activeElement;
      if (aktiv && aktiv !== document.body && (/^(INPUT|TEXTAREA|SELECT)$/.test(aktiv.tagName) || aktiv.isContentEditable)) return true;
      return false;
    }

    function versuchen() {
      if (offen || erledigt || gesendet || !zeitUm || !bedient) return;
      if (document.visibilityState !== 'visible') return;
      if (Date.now() - letzteBewegung < 900) {
        bald();
        return;
      }
      if (window.innerHeight < 500) return;
      if (seite === 'produkt' && kaufbuehneImBild) return;
      if (!angebotGesehen) return;
      if (belegt()) return;
      // In einem anderen Tab inzwischen angemeldet, geschlossen oder Code eingelöst
      if (merkerLesen() || hatCodeCookie()) {
        erledigt = true;
        return;
      }
      oeffnen('angebot');
    }

    function bewegt() {
      letzteBewegung = Date.now();
      bedient = true;
      if (zeitUm) bald();
    }

    ['scroll', 'wheel', 'touchstart', 'touchmove', 'pointerdown', 'keydown'].forEach(function (art) {
      window.addEventListener(art, bewegt, { passive: true });
    });
    ['resize', 'focusout', 'click'].forEach(function (art) {
      window.addEventListener(art, function () { if (zeitUm) bald(); }, { passive: true });
    });
    // close bubbelt nicht; in der Einfangphase am Dokument kommt es von jedem Dialog an
    document.addEventListener('close', function () { if (zeitUm) bald(); }, true);
    document.addEventListener('rs:einwilligung', function () { if (zeitUm) bald(); });
    document.addEventListener('rs:warenkorb:geschlossen', function () { if (zeitUm) bald(); });
    // Wer etwas in den Warenkorb legt, ist auf dem Weg zur Kasse: auf dieser Seite nicht mehr (gestaltung.md 6)
    document.addEventListener('rs:warenkorb:hinzugefuegt', function () { erledigt = true; });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        sichtbarSeit = Date.now();
        uhrStellen();
        if (zeitUm) bald();
      } else {
        if (sichtbarSeit) sichtbarMs += Date.now() - sichtbarSeit;
        sichtbarSeit = 0;
        clearTimeout(uhr);
        clearTimeout(ruheUhr);
      }
    });

    if ('IntersectionObserver' in window) {
      var buehne = seite === 'produkt' ? document.querySelector('[data-rs-kaufbuehne]') : null;
      if (buehne) {
        kaufbuehneImBild = true;
        new IntersectionObserver(function (eintraege) {
          kaufbuehneImBild = eintraege[eintraege.length - 1].isIntersecting;
          if (!kaufbuehneImBild && zeitUm) bald();
        }).observe(buehne);
      }
      var angebot = seite === 'listicle' ? document.querySelector('.rs-lpa') : null;
      if (angebot) {
        var beobachter = new IntersectionObserver(function (eintraege) {
          if (!eintraege[eintraege.length - 1].isIntersecting) return;
          angebotGesehen = true;
          beobachter.disconnect();
          if (zeitUm) bald();
        });
        beobachter.observe(angebot);
      } else {
        angebotGesehen = true;
      }
    } else {
      angebotGesehen = true;
    }

    uhrStellen();
  }

  einrichten();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId === 'rs-popup') einrichten();
  });
})();
